import { createContext } from 'react'

import { BaseMeasureController } from 'core-components/sitebuilder/analytics'
import { createWidget } from 'core-components/sitebuilder/layout/flexItem/helpers/createWidget'
import { createSitePage } from 'core-components/sitebuilder/layout/helpers/sitePages'
import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { IWidgetsData } from 'core-components/sitebuilder/models/IWidgetData'

export interface IFlexGridWrapperContext {
  onSaveWidgetsAsDefault: (page: ISitePage) => Promise<void>
  onFlexSettingsChanged: (flexSettings: IFlexLayout) => void
  getDefaultPageSettings: (pageId: string) => Promise<ISitePage>
  saveWidget: (widget: IWidget) => Promise<IWidget>
  saveGroup?: (groupName: string) => Promise<boolean>
  fetchWidgetGroups: () => Promise<string[]>
  addWidgetToFlexGrid: (widget: IWidget) => Promise<void>
  MeasureController: typeof BaseMeasureController
  canEditSettings: boolean
  isAnonymous: boolean
  updateUserLayout: (layoutCode: string, settings: object) => void
  saveAsDefaultLayout: (sitePage: ISitePage, newWidgetsData: IWidgetsData[]) => Promise<ISitePage>
}

export const FlexGridWrapperContext = createContext<IFlexGridWrapperContext>({
  onSaveWidgetsAsDefault: async () => undefined,
  onFlexSettingsChanged: () => undefined,
  getDefaultPageSettings: async () => createSitePage(),
  saveWidget: async () => createWidget(),
  fetchWidgetGroups: async () => [],
  addWidgetToFlexGrid: async () => undefined,
  MeasureController: BaseMeasureController,
  canEditSettings: false,
  isAnonymous: false,
  updateUserLayout: () => undefined,
  saveAsDefaultLayout: async () => createSitePage(),
})
